import React, { useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { Link } from "react-router-dom";
import MainNav from "../Components/MainNav";
import Footer from "../Components/Footer";
import { motion } from "framer-motion";

// Chamber Images
import club1 from "../Images/club7.jpeg";
import club2 from "../Images/grden2.jpeg";
import club3 from "../Images/sultant-galry.jpeg";
import club4 from "../Images/club9.jpeg";
import club5 from "../Images/sultant-galry1.jpeg";

const clubsData = [
  { 
    id: 1, 
    name: "Sultanate Room", 
    tag: "Royal Heritage Suite",
    capacity: "Up to 30 Guests",
    desc: "Intricately detailed arches, warm lantern glow, and authentic antique relics inspired by the Sultanate era.",
    path: "/sultanroom",
    image: club1 
  },
  { 
    id: 2, 
    name: "Khalsa Room", 
    tag: "Historic Grandeur",
    capacity: "Up to 40 Guests",
    desc: "Rich wooden carvings and ambient lighting showcasing the regal artistry of 19th-century Punjab.",
    path: "/khalsaroom",
    image: club2 
  },
  { 
    id: 3, 
    name: "Mughal Room", 
    tag: "Imperial Banquet",
    capacity: "Up to 35 Guests",
    desc: "Frescoes, hand-painted floral motifs, and an opulent Mughal ambiance for executive dinners and family celebrations.",
    path: "/mughal",
    image: club3 
  },
  { 
    id: 4, 
    name: "Raj Room", 
    tag: "Colonial Charm",
    capacity: "Up to 25 Guests",
    desc: "A blend of British Raj architecture and vintage furniture with direct atmospheric views of historic Lahore.",
    path: "/raj",
    image: club4 
  },
  { 
    id: 5, 
    name: "Sammar Palace", 
    tag: "Panoramic Starlight",
    capacity: "Up to 50 Guests",
    desc: "Perched high with spectacular vistas of the illuminated Badshahi Mosque and vibrant Food Street skyline.",
    path: "/sammr",
    image: club5 
  },
];

const ClubNames = () => {
  const [search, setSearch] = useState("");

  const filteredClubs = clubsData.filter((club) =>
    club.name.toLowerCase().includes(search.toLowerCase()) ||
    club.tag.toLowerCase().includes(search.toLowerCase()) ||
    club.desc.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="club-page-wrapper luxury-dark-page">
      <MainNav />

      {/* Hero Header */}
      <section className="luxury-page-hero text-center">
        <Container>
          <div className="luxury-pill-badge luxury-pill-badge--gold">
            <span>⚜ IMPERIAL RETREATS ⚜</span>
          </div>
          <h1 className="luxury-page-hero__title">Royal Private Chambers</h1>
          <p className="luxury-page-hero__subtitle">
            Exclusive architectural suites offering intimate fine dining, vintage aesthetics, and bespoke hospitality in the heart of Lahore.
          </p>

          {/* Search Box */}
          <div className="luxury-search-box-wrap">
            <div className="luxury-search-box">
              <FaSearch className="luxury-search-icon" />
              <input
                type="text"
                placeholder="Search chambers by name or ambiance..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="luxury-search-input"
              />
              {search && (
                <button 
                  type="button" 
                  className="luxury-search-clear"
                  onClick={() => setSearch("")}
                >
                  ✕
                </button>
              )}
            </div>
          </div>
        </Container>
      </section>

      {/* Chambers Grid */}
      <Container className="luxury-chambers-container pb-5">
        <Row className="g-4 justify-content-center">
          {filteredClubs.length > 0 ? (
            filteredClubs.map((club, index) => (
              <Col lg={4} md={6} sm={12} key={club.id}>
                <motion.div 
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="h-100"
                >
                  <Card className="luxury-chamber-card h-100">
                    <div className="chamber-card__image-wrap">
                      <div 
                        className="chamber-card__image" 
                        style={{ backgroundImage: `url(${club.image})` }} 
                      />
                      <div className="chamber-card__gradient" />
                      <span className="chamber-card__badge">{club.tag}</span>
                      <span className="chamber-card__capacity">{club.capacity}</span>
                    </div>

                    <Card.Body className="chamber-card__body">
                      <h3 className="chamber-card__title">{club.name}</h3>
                      <p className="chamber-card__desc">{club.desc}</p>
                      
                      <div className="chamber-card__footer">
                        <Link to={club.path} className="chamber-card__link">
                          <span>Explore Chamber</span>
                          <span className="arrow-icon">→</span>
                        </Link>
                      </div>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))
          ) : (
            <Col xs={12} className="text-center py-5">
              <div className="luxury-no-results">
                <span className="no-results-icon">⚜</span>
                <p>No chambers found matching &ldquo;{search}&rdquo;.</p>
                <button 
                  className="luxury-btn-ghost mt-2" 
                  onClick={() => setSearch("")}
                >
                  View All Chambers
                </button>
              </div>
            </Col>
          )}
        </Row>
      </Container>

      <Footer />
    </div>
  );
};

export default ClubNames;
